import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

const Stats = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })
  const { t } = useTranslation()

  const stats = [
    {
      number: "100+",
      label: t('stats.projects.label'),
      description: t('stats.projects.description')
    },
    {
      number: "24/7",
      label: t('stats.expertise.label'),
      description: t('stats.expertise.description')
    },
    {
      number: "360°",
      label: t('stats.industry.label'),
      description: t('stats.industry.description')
    },
    {
      number: "5+",
      label: t('stats.experience.label'),
      description: t('stats.experience.description')
    }
  ]

  return (
    <section ref={ref} className="section-padding bg-gradient-to-r from-primary-600 to-accent-600">
      <div className="container-max">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('stats.title')}
          </h2>
          <p className="text-xl text-primary-100 max-w-3xl mx-auto">
            {t('stats.description')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="text-center"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 card-hover">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={isInView ? { scale: 1 } : {}}
                  transition={{ delay: index * 0.1 + 0.3, duration: 0.5, type: "spring" }}
                  className="text-4xl md:text-5xl font-bold text-white mb-4"
                >
                  {stat.number}
                </motion.div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {stat.label}
                </h3>
                <p className="text-primary-100 text-sm leading-relaxed">
                  {stat.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Stats
